import React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { styled } from '@mui/system';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';

const Root = styled('footer')(({ theme }) => ({
  marginTop: 'auto',
  padding: theme.spacing(4, 0),
  textAlign: 'center',
  display: 'flex',
    borderTop: '1px solid',
    borderColor: '#e5e7eb',
}));

const FooterContent = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
});

const CopyrightText = styled(Typography)({
  flexGrow: 1,
  textAlign: 'left',
});

const VersionText = styled(Typography)({
  fontSize: 10
});

const IconContainer = styled(Grid)({
  display: 'flex',
//   justifyContent: 'flex-end',
});

const IconLink = styled(Link)({
  margin: '0 8px',
  '&:hover': {
    textDecoration: 'none',
  },
});

const Footer = () => {

  const currentYear = new Date().getFullYear();

  return (
    <Root>
      <Container>
        <FooterContent>
            <div>
                 <div>
                          kontakt@dietaniemowlaka.pl
                          </div>
          <CopyrightText variant="body2" color="textSecondary">
           &copy; {currentYear} Dieta Niemowlaka. All rights reserved.
          </CopyrightText>

                   <VersionText
                          variant="caption">
              {process.env.REACT_APP_VERSION}
                        </VersionText>
          </div>

          <IconContainer item xs={12} sm={6} md={4}>
            <IconLink href="https://www.facebook.com/dietaniemowlaka/" target="_blank" rel="noopener">
              <FacebookIcon fontSize="large" />
            </IconLink>

            <IconLink href="https://www.instagram.com/dietaniemowlaka" target="_blank" rel="noopener">
          <InstagramIcon fontSize="large" />
           </IconLink>
           </IconContainer>

        </FooterContent>
      </Container>
    </Root>
  );
};

export default Footer;
